// OpenRouter API Client

import baseUrl from '../../../config';
import { routes } from '../../../services/api/routes';

export async function callAPI(messages) {
  const accessToken = localStorage.getItem('token');

  const response = await fetch(`${baseUrl}${routes.editor.aiChat}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      messages,
      reasoning: {
        effort: process.env.AI_CHAT_EDITOR_REASONING_LEVEL || 'low'
      }
    })
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));

    if (response.status === 429) {
      const err = new Error(data.error?.message || data.error || 'Too many requests. Please wait a moment and try again.');
      err.code = 'RATE_LIMITED';
      throw err;
    }

    if (response.status === 403) {
      const err = new Error(data.error?.message || data.error || 'This feature is not available on your plan.');
      err.code = 'FORBIDDEN';
      throw err;
    }

    throw new Error(data.error?.message || data.error || response.statusText);
  }

  return response.json();
}
